module.exports = __webpack_public_path__ + "img/ic-support-white.ed6a8cd5.svg";